export default "__VITE_ASSET__BVi$XjMa__"